import React from 'react';
import { styled, CommonStyles } from '@teko/ds-foundation';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledNavigation = styled.div`
  ${CommonStyles};
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background-color: ${({ theme }) => theme.colors.white};
  padding-bottom: env(safe-area-inset-bottom);
  transition: bottom 0.4s;
  z-index: ${(p) => p.zIndex || 1060};
`;
const BottomNavigationBar = (_a) => {
  var _b = _a, {
    zIndex,
    children
  } = _b, rest = __objRest(_b, [
    "zIndex",
    "children"
  ]);
  return /* @__PURE__ */ React.createElement(StyledNavigation, __spreadValues({
    zIndex
  }, rest), children);
};
const BottomActionBar = styled(BottomNavigationBar)`
  min-height: 60px;
  padding-left: 16px;
  padding-right: 16px;
  border-top: 1px solid #ddd;
  -webkit-backface-visibility: hidden;
  align-items: center;
  justify-content: space-between;
`;

export { BottomActionBar, BottomNavigationBar };
